import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import Textarea from "react-autosize-textarea";

import { vote } from "../../api.js";
import VotesListing from "./votes-listing.js";
import { VoterNameContext } from "../../voter-duckling.js";

import styles from "./poll-booth.module.css";
import layout from "../layout.module.css";

let PollBooth = ({ game, votes, setVotes }) => {
  let { voter, dispatch } = useContext(VoterNameContext);
  let [rationale, setRationale] = useState("");
  let [hasVoted, setHasVoted] = useState(false);
  let [hasError, setHasError] = useState(false);

  // debugger;

  let allVotes = votes[game.teamA && game.teamA.owner]
    ? votes[game.teamA.owner]
        .concat(votes[game.teamB.owner])
        .map((v) => v.voter.toLowerCase())
    : [];

  let alreadyVoted = voter && allVotes.includes(voter);

  let votingIsOpen = game.teamA && game.teamB && game.donezo() !== true;

  let thankYou = (
    <p className={styles.thanks}>
      thanks for voting!
      <br />
      <Link to="/">go back to game list</Link>
    </p>
  );

  let votingMachine = (
    <>
      <p className={styles.voteCount}>{allVotes.length} votes cast so far</p>
      <div className={styles.voterName}>
        <p className={styles.label}>Who are you?</p>
        <input
          type="text"
          className={styles.input}
          value={voter}
          id="voterName"
          onChange={(e) => {
            dispatch({ type: "SET_NAME", payload: e.target.value });

            if (allVotes.includes(e.target.value.toLowerCase())) {
              setHasError(true);
            } else {
              setHasError(false);
            }
          }}
        />
        <p className={styles.label}>Rationale (optional):</p>
        <Textarea
          className={styles.rationale}
          value={rationale}
          onChange={(e) => {
            setRationale(e.target.value);
          }}
        />
      </div>
      {hasError || alreadyVoted ? (
        <p className={styles.error}>you already voted in this one!</p>
      ) : !voter ? (
        <p className={styles.instruction}>
          you must enter a name before you can vote
        </p>
      ) : (
        <>
          <div className={layout.container}>
            <div className={layout.left}>
              <button
                className={styles.button}
                onClick={() =>
                  voter &&
                  vote(game.number, voter, game.teamA.owner, rationale).then(
                    (response) => {
                      setVotes((prevVotes) => ({
                        ...prevVotes,
                        [game.teamA.owner]: prevVotes[game.teamA.owner].concat([
                          { voter, rationale, winner: game.teamA.owner },
                        ]),
                      }));
                      setHasVoted(true);
                    }
                  )
                }
              >
                vote for {game.teamA && game.teamA.owner}
              </button>
            </div>
            <div className={layout.right}>
              <button
                className={styles.button}
                onClick={() =>
                  voter &&
                  vote(game.number, voter, game.teamB.owner, rationale).then(
                    (response) => {
                      setVotes((prevVotes) => ({
                        ...prevVotes,
                        [game.teamB.owner]: prevVotes[game.teamB.owner].concat([
                          { voter, rationale, winner: game.teamB.owner },
                        ]),
                      }));
                      setHasVoted(true);
                    }
                  )
                }
              >
                vote for {game.teamB && game.teamB.owner}
              </button>
            </div>
          </div>
        </>
      )}
      <div className={styles.resultsSection}>
        <h3 className={styles.results}>Already voted:</h3>
        {allVotes.map((v) => (
          <p key={v} className={styles.resultsOwner}>
            {v}
          </p>
        ))}
      </div>
    </>
  );

  let votingSection = (
    <>
      <div className={styles.votingSection}>
        {hasVoted ? thankYou : votingMachine}
      </div>
      {game.debugVotes && <VotesListing game={game} votes={votes} />}
    </>
  );

  return votingIsOpen ? (
    votingSection
  ) : (
    <VotesListing game={game} votes={votes} />
  );
};

export default PollBooth;
